/*
 * A discharge summary that is on the mother's file but is about her baby (KIN-1949).
 *
 * MN-CMS sends one summary per baby and identifies the baby in PID.5/PID.7, so a newborn the
 * practice has not registered yet matches nobody. Since KIN-1926 the backend finds the mother
 * through PID.21 and files the summary on her record — visible instead of parked in the
 * unassigned queue — which means a document about her baby now sits among her own.
 *
 * `resolvedMotherPatientId` is the entire contract:
 *   null      an ordinary document belonging to the patient whose file it is on;
 *   non-null  this document is about that patient's baby.
 *
 * Nothing is inferred from the message type or the title text, both of which would be guesses.
 *
 * This survives KIN-1687 (patient merge) on purpose. When that lands, KIN-1926 creates the baby's
 * own record and `patientId` moves to the baby while `resolvedMotherPatientId` keeps the
 * relationship — so the row stays labelled, it simply sits on a different file.
 */

export const isBabyDischargeSummary = (result) =>
  result?.resolvedMotherPatientId !== null &&
  result?.resolvedMotherPatientId !== undefined;

/*
 * Deliberately not named after the child. PID.5's forename is a hospital placeholder built from
 * the mother's own first name — a real one reads as "<mother's forename>girl" — so it is not the
 * baby's name, and it changes the moment the parents register one.
 */
export const BABY_DISCHARGE_LABEL = "Baby's discharge summary";
